// @flow

import StyledFormWrapper from './StyledFormHeader'

export default StyledFormWrapper
